'use strict';

export default function ($stateProvider) {
  'ngInject';
  $stateProvider
    .state('create', {
      url: '/create',
      template: '<create></create>',
      params: {
      	params: null
      },
    });
}



// WEBPACK FOOTER //
// ./client/app/create/create.routes.ts